import React, { useEffect, useMemo, useState } from "react";
import { Grid, Stepper, Step, StepLabel } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import PageConfig, { PageContext } from "../../configs";
// import TriggerOTPView from "../trigger-otp-view";
import AddEmailAddressView from "../add-email-address-view/index";
import OTPVerificationView from "../otp-verification-view";

const { FORM_UI_STATE, FORM_STEPPER_STEPS } = PageConfig;

const EmailVerificationForm = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { authAccount } = useSelector((state) => state.application);

  const [formUIState, setFormUIState] = useState(FORM_UI_STATE.ADD_NEW_EMAIL);
  const [token, setToken] = useState("");
  const [retryTimeout, setRetryTimeout] = useState(0);
  const [emailAddress, setEmailAddress] = useState("");
  const [ignoredTriggerOTP, setIgnoredTriggerOTP] = useState(false);

  const activeStep = useMemo(() => {
    const activeObj = FORM_STEPPER_STEPS.find(
      (element) => element.state === formUIState
    );
    return activeObj?.step ?? 0;
  }, [formUIState]);

  useEffect(() => {
    setEmailAddress(authAccount.email ?? "");
  }, [authAccount]);

  return (
    <PageContext.Provider
      value={{
        formUIState,
        setFormUIState,
        emailAddress,
        setEmailAddress,
        ignoredTriggerOTP,
        setIgnoredTriggerOTP,
        token,
        setToken,
        retryTimeout,
        setRetryTimeout,
      }}
    >
      <Grid
        container
        direction="column"
        className="row-gap-16"
        classes="email-verification-form"
      >
        <Grid item className="form-step-root-container">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className={`stepper-${language}`}
          >
            {FORM_STEPPER_STEPS.map((element) => (
              <Step key={element.step}>
                <StepLabel>{t(element.label)}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        {formUIState === FORM_UI_STATE.ADD_NEW_EMAIL && <AddEmailAddressView />}
        {/* {formUIState === FORM_UI_STATE.SEND_OTP && <TriggerOTPView />} */}
        {formUIState === FORM_UI_STATE.VERIFY_OTP && <OTPVerificationView />}
      </Grid>
    </PageContext.Provider>
  );
};

export default EmailVerificationForm;
